export default "__VITE_ASSET__DuImd3ul__"